import { useCurrentCompany } from '@bonusly/who-am-i';

import { useManagerCheckInSettings } from './use-manager-check-in-settings';

/**
 * Hook to determine if check-ins are configured for the current user/company.
 * Check-ins are considered configured when:
 * 1. The company has mandatory check-ins enabled (and past the effective date), OR
 * 2. The current user's manager has a cadence set in their manager_check_in_settings
 *
 * @returns boolean - true if check-ins are configured, false otherwise
 */
export const useCheckInsConfigured = (): boolean => {
	const company = useCurrentCompany();
	const { data: managerCheckInSettings } = useManagerCheckInSettings();

	// Check if company has mandatory check-ins enabled
	const companyCheckInSettings = company?.check_in_settings;
	const isCompanyMandatory =
		companyCheckInSettings?.mandatory && (!companyCheckInSettings?.effective_date || new Date() >= new Date(companyCheckInSettings.effective_date));

	// Check if manager has a cadence set
	const managerHasCadence = !!managerCheckInSettings?.cadence;

	return isCompanyMandatory || managerHasCadence;
};
